module.exports = __webpack_public_path__ + "img/bg6.ba3c3649.png";